import { render, staticRenderFns } from "./ConfirmUpload.vue?vue&type=template&id=323be27e&scoped=true&lang=pug&"
import script from "./ConfirmUpload.vue?vue&type=script&lang=js&"
export * from "./ConfirmUpload.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmUpload.vue?vue&type=style&index=0&id=323be27e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323be27e",
  null
  
)

export default component.exports